module.exports = __webpack_public_path__ + "static/media/ic_highlight_off_24px.e16b0857.svg";